module.exports = __webpack_public_path__ + "img/insights-summary.760963c5.png";